import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';

import Button from '@ts-core/components/Button';

interface BaseExerciseQuestionsFormProps {
  children: React.ReactNode;

  addQuestionButtonTitle?: React.ReactNode;

  questionsCountText: string;
  onChangeQuestionCount?: React.ChangeEventHandler<HTMLTextAreaElement>;

  onAddQuestion?: () => void;

  initialQuestionNumber?: number;
  onChangeInitialQuestionNumber?: (value: number) => void;
}

const BaseExerciseQuestionsForm = (props: BaseExerciseQuestionsFormProps) => {
  const {
    addQuestionButtonTitle,
    questionsCountText,
    initialQuestionNumber,
    onChangeQuestionCount,
    onChangeInitialQuestionNumber,
    onAddQuestion,
    children,
  } = props;
  const intl = useIntl();

  const handleChangeInitialQuestionNumber = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (!onChangeInitialQuestionNumber) return;
      const value = parseInt(event.target.value, 10) || 0;
      onChangeInitialQuestionNumber(value);
    },
    [onChangeInitialQuestionNumber]
  );

  return (
    <Stack direction="column" spacing={2} alignItems="flex-start" width="100%">
      {onChangeQuestionCount && (
        <TextField
          label={intl.formatMessage({ id: 'field.exercise.questionsCount' })}
          variant="standard"
          value={questionsCountText}
          onChange={onChangeQuestionCount}
          fullWidth
          type="number"
        />
      )}
      {onChangeInitialQuestionNumber && (
        <TextField
          sx={{ pb: 3 }}
          label={intl.formatMessage({ id: 'field.initialQuestionNumber' })}
          variant="standard"
          value={initialQuestionNumber || ''}
          onChange={handleChangeInitialQuestionNumber}
          fullWidth
          type="number"
        />
      )}
      {children}
      {onAddQuestion && (
        <Button variant="contained" disableRipple color="secondary" startIcon={<AddIcon />} onClick={onAddQuestion}>
          {addQuestionButtonTitle || intl.formatMessage({ id: 'button.addQuestion' })}
        </Button>
      )}
    </Stack>
  );
};

export default BaseExerciseQuestionsForm;
